import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-success-banner',
    templateUrl: './success-banner.component.html',
    styleUrls: ['./success-banner.component.scss'],
    standalone: false
})
export class SuccessBannerComponent implements OnInit {

  @Input() successTitle: string
  @Input() successMessage: string
  @Input() buttonText: string

  currentLang: string

  constructor(public translateService: TranslateService) {

    this.currentLang = translateService.currentLang
    translateService.onLangChange.subscribe(lang => {
      this.currentLang = lang.lang
    })
  }

  ngOnInit(): void {}

}
